import React from 'react';

export interface TableFooterProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
  className?: string;
}

const TableFooter = ({ children, className = '', ...props }: TableFooterProps) => (
  <tfoot className={className} {...props}>
    {children}
  </tfoot>
);

export default TableFooter;
